import downloadFile from './download-file';

export default async function downloadLinkAsFile(
  fileUrl?: string,
  fileName?: string,
  onError?: (error: string) => void,
) {
  if (!fileUrl) {
    onError?.('File URL is required.');
    return;
  }

  if (!fileName) {
    onError?.('File name is required.');
    return;
  }

  const response = await fetch(fileUrl);

  if (response.ok) {
    const blob = await response.blob();
    downloadFile(blob, fileName);
  } else {
    onError?.('File not found.');
  }
}
